import { EThemeColor } from 'src/styles/theme/utils/enums';
import { addFramesStyles, addPaddingStyles, addTransition, getThemeColor } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';
import { INGGoldContainer } from './NGGoldContainer.type';

export const StyledCardContainer = styled.div<INGGoldContainer>`
	position: relative;
	z-index: 2;

	border-radius: 5px;
	border-width: 1px;
	border-style: solid;

	align-self: stretch;

	border: 1px solid;

	${(p) => {
		return `background-color: ${getThemeColor(p.theme, p.backgroundColor || EThemeColor.black)};`;
	}}

	${addTransition()}

	${(p) =>
		p.transparentBorder
			? css`
					border: none;
			  `
			: css`
					border-color: ${getThemeColor(p.theme, p.colorVariant || EThemeColor.gold)}80;
			  `}

	& > span {
		display: block;
		${(p) => addPaddingStyles(p)}
		${(p) => addFramesStyles(p)}
	}
`;

export const StyledHoverGlow = styled.span<{ isVisible: boolean; colorVariant?: EThemeColor }>`
	position: absolute;
	z-index: 999;

	width: 500px;
	height: 500px;

	border-radius: 100%;

	margin-left: -250px;
	margin-top: -250px;

	user-select: none;
	pointer-events: none;

	${(p) => {
		const color = getThemeColor(p.theme, p.colorVariant || EThemeColor.gold);

		return `background-image: radial-gradient(ellipse at center, ${color + '20'} 0%, ${color + '00'} 50%);`;
	}}

	${addTransition('opacity', 0.4)}

	${(p) =>
		p.isVisible
			? `
		opacity: 0.5;
	`
			: `
		opacity: 0;
	`}
`;

export const StyledFullContainer = styled.div<any>`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;

	z-index: 100;

	pointer-events: none;
	user-select: none;

	overflow: hidden;
`;
